module.exports = __webpack_public_path__ + "img/como-funciona-relink-4.9cc6046.webp";